declare const DUMMY_HOST: string;

type Primitive = number | string | boolean | undefined | null;
interface UrlObject {
    params: Record<string, Primitive[] | Primitive>;
    hash: string;
    href: string;
    search: string;
    host: string;
    hostname: string;
    port: string;
    protocol: string;
    pathname: string;
}

interface StaticProps {
    stringify: (input: Record<string, string | string[] | number | null> | string[][]) => string;
}

declare const urlParser: ((urlString: string) => UrlObject) & StaticProps;

export default urlParser;
